import { defineComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, toDisplayString, createCommentVNode } from "vue";
const _hoisted_1 = { class: "notification-list-item__content" };
const _hoisted_2 = { class: "notification-list-item__avatar" };
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1,
  class: "notification-list-item__avatar-fallback"
};
const _hoisted_5 = { class: "notification-list-item__texts" };
const _hoisted_6 = { class: "notification-list-item__message" };
const _hoisted_7 = {
  key: 0,
  class: "notification-list-item__badge"
};
const _hoisted_8 = { class: "notification-list-item__meta" };
const _hoisted_9 = {
  key: 0,
  class: "notification-list-item__time"
};
const _hoisted_10 = {
  key: 1,
  class: "notification-list-item__unread-dot"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NotificationListItem",
  props: {
    item: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["notification-list-item", {
          "notification-list-item--highlighted": __props.item.isHighlighted
        }])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            __props.item.avatarUrl ? (openBlock(), createElementBlock("img", {
              key: 0,
              src: __props.item.avatarUrl,
              alt: "",
              class: "notification-list-item__avatar-image"
            }, null, 8, _hoisted_3)) : (openBlock(), createElementBlock("span", _hoisted_4, toDisplayString(__props.item.initials), 1))
          ]),
          createElementVNode("div", _hoisted_5, [
            createElementVNode("p", _hoisted_6, toDisplayString(__props.item.message), 1),
            __props.item.context ? (openBlock(), createElementBlock("span", _hoisted_7, toDisplayString(__props.item.context), 1)) : createCommentVNode("", true)
          ])
        ]),
        createElementVNode("div", _hoisted_8, [
          __props.item.timeLabel ? (openBlock(), createElementBlock("span", _hoisted_9, toDisplayString(__props.item.timeLabel), 1)) : createCommentVNode("", true),
          __props.item.isUnread ? (openBlock(), createElementBlock("span", _hoisted_10)) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=NotificationListItem.vue2.js.map
